import { FC, useEffect } from 'react';

import { useMediaViewerControls, useMediaViewerInfo } from '@hh.ru/magritte-ui';

export const SyncInitialGalleryItem: FC<{ index: number }> = ({ index }) => {
    const { goToSlideIndex } = useMediaViewerControls();
    const { slidesCount } = useMediaViewerInfo();

    useEffect(() => {
        if (slidesCount > 0 && index > 0) {
            goToSlideIndex(index);
        }
    }, [slidesCount, index, goToSlideIndex]);
    return null;
};
